module.exports = __webpack_public_path__ + "static/img/far3.fd9626a8.png";